import React from "react";
import { Check, X } from "lucide-react";
import { AUDIENCE } from "../mock";
import Reveal from "./Reveal";

const WhoItsFor = () => {
  return (
    <section className="relative py-24 sm:py-28 border-t border-white/[0.05]">
      <div className="max-w-6xl mx-auto px-5 sm:px-6">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-start">
          {/* Left copy */}
          <Reveal className="lg:sticky lg:top-28">
            <span className="section-label">{AUDIENCE.label}</span>
            <h2 className="font-display font-800 text-white text-[2rem] sm:text-[2.9rem] leading-[1.03] mt-4 tracking-tight">
              {AUDIENCE.title}
            </h2>

            <div className="mt-8 space-y-4">
              <div className="flex items-start gap-3">
                <span className="mt-0.5 flex-shrink-0 w-6 h-6 rounded-full bg-[#d69b4e]/15 border border-[#d69b4e]/30 flex items-center justify-center">
                  <Check className="w-3.5 h-3.5 text-[#e8b876]" strokeWidth={3} />
                </span>
                <p className="text-[#a49e92] leading-relaxed text-[0.98rem]">{AUDIENCE.subtitlePos}</p>
              </div>
              <div className="flex items-start gap-3">
                <span className="mt-0.5 flex-shrink-0 w-6 h-6 rounded-full bg-white/[0.05] border border-white/10 flex items-center justify-center">
                  <X className="w-3.5 h-3.5 text-[#7c7669]" strokeWidth={3} />
                </span>
                <p className="text-[#a49e92] leading-relaxed text-[0.98rem]">{AUDIENCE.subtitleNeg}</p>
              </div>
            </div>
          </Reveal>

          {/* Right cards */}
          <div className="space-y-4">
            {AUDIENCE.cards.map((card, i) => (
              <Reveal
                key={card.num}
                delay={i * 120}
                className="group relative rounded-[22px] border border-white/[0.08] bg-gradient-to-b from-white/[0.035] to-white/[0.01] p-7 hover:border-[#d69b4e]/30 transition-all duration-300 overflow-hidden"
              >
                <div className="absolute -top-6 -right-2 font-display font-800 text-[5rem] leading-none text-white/[0.03] select-none group-hover:text-[#d69b4e]/[0.06] transition-colors">
                  {card.num}
                </div>
                <span className="font-display font-700 text-[1rem] gold-text">{card.num}</span>
                <h3 className="font-display font-700 text-white text-[1.3rem] mt-3 leading-snug">
                  {card.title}
                </h3>
                <p className="text-[#989286] mt-3 leading-relaxed text-[0.94rem] max-w-md">
                  {card.body}
                </p>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhoItsFor;
